import {
  findNodeById,
  RuleApplyResultWithoutMessages,
  setNodeActiveById,
  toggleChapterInTree,
} from "../../../../components/ReportChapterTree/reportChaptersTreeUtils";
import { IAkustikkProsjektinfo } from "@mcapps/shared/reportSchemas/akustikk/prosjektinfoSchema";
import { IReportChapterNode } from "@mcapps/shared/reportSchemas/kapitelSchema";

export const AKUSTIKK_DEPARTMENTS = ["-"];

export const ruleSetActiveBasedOnEarlierOptions = (
  prosjektinfo: IAkustikkProsjektinfo,
  kapitler: IReportChapterNode[],
): RuleApplyResultWithoutMessages => {
  let kap = kapitler;

  const isForprosjektOrTotalEnterprise =
    prosjektinfo.fase.skisseForprosjekt.isActive === true ||
    prosjektinfo.fase.totalenterprisegrunnlag.isActive === true;

  const isBolig = prosjektinfo.typeBygg.bolig.isActive === true;
  const isFlerFamiliehus = prosjektinfo.typeBygg.bolig.flerFamiliehus.isActive === true;
  const isKontorEllerSkolebygg =
    prosjektinfo.typeBygg.undervisningsbygg.isActive === true || prosjektinfo.typeBygg.kontorbygg.isActive === true;
  const isProduksjonsbygg = prosjektinfo.typeBygg.produksjonsbygg.isActive === true;
  const hasHeis = prosjektinfo.konstruksjonstype.heis.isActive === true;
  const hasLydEllerTaleOverforing =
    prosjektinfo.typeBygg.undervisningsbygg.isActive === true ||
    prosjektinfo.typeBygg.kontorbygg.isActive === true ||
    prosjektinfo.typeBygg.helsebygg.isActive === true ||
    prosjektinfo.typeBygg.barnehage.isActive === true ||
    prosjektinfo.typeBygg.produksjonsbygg.isActive === true ||
    prosjektinfo.typeBygg.kulturbygg.isActive === true;
  const addLydtegninger = prosjektinfo.vedlegg.lydtegninger.isActive === true;
  const hasHenvisningTilVedlegg = prosjektinfo.vedlegg.tabellEllerTekst.henvisningVedlegg.isActive === true;

  const hasByggOgAnleggsstoy = Boolean(findNodeById(kap, "kap2_3")?.isActive);
  const hasUtendorsStoykilde = Boolean(findNodeById(kap, "kap4")?.isActive);
  const hasStoyFraFlyOgHelikoptertrafikk = Boolean(findNodeById(kap, "kap4_1")?.isActive);

  const sync = (id: string, shouldBeActive: boolean) => {
    const node = findNodeById(kap, id);
    if ((node?.isActive ?? false) !== shouldBeActive) {
      kap = shouldBeActive ? setNodeActiveById(kap, id, true) : toggleChapterInTree(kap, id, false);
    }
  };

  sync("kap2_8", isForprosjektOrTotalEnterprise);
  sync("kap5_1", isBolig);
  sync("kap5_1_1", isBolig);
  sync("kap5_2", isFlerFamiliehus);
  sync("kap6_7", hasUtendorsStoykilde);
  sync("kap6_8", hasStoyFraFlyOgHelikoptertrafikk);
  sync("kap7_3", isKontorEllerSkolebygg);
  sync("kap8_3", hasHeis);
  sync("kap9", hasLydEllerTaleOverforing);
  sync("kap10_3_3", isBolig);
  sync("kap10_3_5", hasHeis);
  sync("vedleggA", hasHenvisningTilVedlegg);
  sync("vedleggB", hasByggOgAnleggsstoy);
  sync("vedleggE", addLydtegninger);
  sync("vedleggF", isProduksjonsbygg);

  return { kapitler: kap };
};

export const applyAkustikkStickyRules = (
  prosjektInfo: IAkustikkProsjektinfo,
  kapitler: IReportChapterNode[],
): RuleApplyResultWithoutMessages => {
  let out = kapitler;

  const rules = [ruleSetActiveBasedOnEarlierOptions];

  for (const r of rules) {
    const res = r(prosjektInfo, out);
    out = res.kapitler;
  }

  return { kapitler: out };
};

const mergeAkustikkRule = (
  acc: RuleApplyResultWithoutMessages,
  next: RuleApplyResultWithoutMessages,
): RuleApplyResultWithoutMessages => ({
  kapitler: next.kapitler,
});

export const applyAllAkustikkRules = (
  prosjektInfo: IAkustikkProsjektinfo,
  kapitler: IReportChapterNode[],
): RuleApplyResultWithoutMessages => {
  let acc: RuleApplyResultWithoutMessages = { kapitler };

  acc = mergeAkustikkRule(acc, applyAkustikkStickyRules(prosjektInfo, acc.kapitler));
  // acc = mergeRule(acc, applyAnotherRule(acc.kapitler));
  // acc = mergeRule(acc, applyThirdRule(acc.kapitler));

  return acc;
};
